import a from "./chunk1158.js";
import P from "./chunk1159.js";
import S from "./chunk948.js";
import c from "./chunk1160.js";
function k(r) {
  var t;
  const {
    elementType: p,
    externalSlotProps: s,
    ownerState: e,
    skipResolvingSlotProps: n = !1,
    ...l
  } = r, o = n ? {} : a(s, e), {
    props: f,
    internalRef: i
  } = P({
    ...l,
    externalSlotProps: o
  }), m = S(i, o == null ? void 0 : o.ref, (t = r.additionalProps) == null ? void 0 : t.ref);
  return c(p, {
    ...f,
    ref: m
  }, e);
}
export {
  k as default
};
